import { IServicePageState } from '../../types/redux/servicePage';

export const initialState = {
  deviceType: 'desktop' as const,
};

export function servicePageReducer(state: IServicePageState = initialState) {
  return state;
}
